/**
 * Нэвтрэх шаардлагатай үйлдэл дээр хэрэглэгчийн байсан хуудсыг хадгалж,
 * нэвтэрсний дараа тэр хуудас руу нь буцаахад ашиглана.
 * sessionStorage-д хадгалдаг тул social login-ий redirect-ийн дараа ч хадгалагдана.
 */

const STORAGE_KEY = 'zangia:pending-auth-redirect';

export function getCurrentPath(): string {
  return `${window.location.pathname}${window.location.search}`;
}

export function savePendingAuthRedirect(path: string = getCurrentPath()) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage боломжгүй — буцаалтгүйгээр үргэлжилнэ.
  }
}

export function clearPendingAuthRedirect() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Хадгалсан замыг авч устгана. Зөвхөн дотоод (`/`-ээр эхэлсэн) замыг буцаана. */
export function takePendingAuthRedirect(): string | null {
  let path: string | null = null;
  try {
    path = window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
  clearPendingAuthRedirect();
  return path?.startsWith('/') && !path.startsWith('//') ? path : null;
}
